import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Modal } from '../common/Modal';

interface HelpModalProps {
	isOpen: boolean;
	showLiveChat?: boolean;
	showWhatsApp?: boolean;
	showCall?: boolean;
	showTutorial?: boolean;
	phoneNumber?: string;
	onClose: () => void;
	onTutorialClicked: () => void;
}

interface HelpModalState {}

export class HelpModal extends React.Component<HelpModalProps, HelpModalState> {
	constructor(props: HelpModalProps) {
		super(props);

		this.state = {};
	}

	render() {
		return (
			<Modal
				isOpen={this.props.isOpen}
				closeOnBackdropClick={true}
				onClose={this.props.onClose}
				header={
					<h2>
						<FormattedMessage id="helpModal.headline" />
					</h2>
				}
			>
				<>
					<Paragraph>
						<FormattedMessage id="helpModal.description" />
					</Paragraph>
					<ButtonContainer>
						{this.props.showLiveChat && (
							<button className="button-secondary" disabled={true}>
								<FormattedMessage id="button.liveChat" />
							</button>
						)}
						{this.props.showCall && this.props.phoneNumber && (
							<button
								className="button-secondary"
								disabled={this.props.phoneNumber ? false : true}
								onClick={(e: any) => {
									if (this.props.phoneNumber) {
										window.location.assign(`tel:${this.props.phoneNumber}`);
									}
								}}
							>
								<FormattedMessage id="button.call" />
							</button>
						)}
						{this.props.showWhatsApp && (
							<button className="button-secondary" onClick={(e: any) => {}}>
								<FormattedMessage id="button.showWhatsApp" />
							</button>
						)}
						{this.props.showTutorial && (
							<button className="button-secondary" onClick={this.props.onTutorialClicked}>
								<FormattedMessage id="button.showTutorial" />
							</button>
						)}
					</ButtonContainer>
				</>
			</Modal>
		);
	}
}

const Paragraph = styled.p`
	text-align: left;
	margin-bottom: 2rem;
`;

const ButtonContainer = styled.p`
	display: grid;
	justify-content: center;
	grid-row-gap: 1rem;
`;
